export default "__VITE_ASSET__wd54br7Y__"